// Modules
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { AUTH_SERVICES } from 'constants';
import { Page, PageHeader, PageContent, ActionSection } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import Filters from 'modules/filters/filters';
import Pager from 'components/widgets/pager/pager';
import Person from 'services/data/person';
import UsersTable from 'components/models/person/users-table';
import exportCSV from 'utils/export-csv';

import * as actions from './store/actions';


// Component
class People extends React.Component {
  static propTypes = {
    people: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number,
    query: PropTypes.object
  };

  constructor() {
    super();

    this.search = this.search.bind(this);
    this.export = this.export.bind(this);

    this.filterConfig = {
      basic: ['search', 'company'],
      defaults: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = Person.formatQuery(query || this.props.query);
    fullQuery.where.role = { in: Person.userRoles };
    
    Promise.props({
      people: Person.find(fullQuery),
      count: Person.count({ where: fullQuery.where })
    })
      .then((response) => {
        actions.set({ fetching: false, count: response.count, people: response.people });
      })
      .catch(alerts.catchError);
  }

  export() {
    const fullQuery = Person.formatQuery(this.props.query);
    fullQuery.where.role = { in: Person.userRoles };
    delete fullQuery.limit;

    Person.find(fullQuery)
      .then((people) => {
        const header = ['First Name', 'Last Name', 'Security Role', 'App Roles'];

        const data = _.map(people, person => {
          const roles = person.externalAppAuthRoles;
          const appRoles = _.map(AUTH_SERVICES, service => {
            const hasRoles = roles[service] && roles[service].length;

            if (!hasRoles) return;

            return `${service}: ${_.join(roles[service], ', ')}`;
          });

          return [
            _.get(person, 'firstName', ''),
            _.get(person, 'lastName', ''),
            _.get(person, 'role', ''),
            _.join(_.compact(appRoles), '\n')
          ];
        });

        exportCSV(data, 'users.csv', { header });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { people, fetching, count } = this.props;

    const headerActions = (
      <div className="header-actions">
        <PrimaryButton onClick={this.export} disabled={_.isEmpty(people)}>Export</PrimaryButton>
      </div>
    );

    return (
      <Page>
        <PageHeader title="Users" actions={headerActions}>
          <ActionSection>
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching && _.isEmpty(people)}
          emptyText="No users, adjust your filters!"
          emptyTextIcon="svg/filter.svg"
          showEmptyText={!fetching && _.isEmpty(people)}
        >
          <UsersTable people={people} />
          <Pager count={count} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  people: state.people.people,
  fetching: state.people.fetching,
  count: state.people.count,
  query: state.location.query
}))(People);
